module.exports = __webpack_public_path__ + "img/agv1.b96a7327.jpg";